import Loadable from '@townsquare/loadable';

export const ReactionUpdateAction = Loadable({
	loader: () => import(/* webpackChunkName: "ReactionUpdateAction" */ './ReactionUpdateAction'),
	loading: () => null,
});
